import React from 'react'
import Select from 'react-select'

const options = [
  'Hilti Svenska AB',
  'Hilti GB',
  'Hilti FI',
  'Hilti DK',
  'Alcadon',
  'Beijer Byggmaterial',
  'Stark Suomi Oy',
  'Lambertsson',
  'Cramo',
  'Derome',
  'Epiroc',
  'Gullviks',
  'Hallsjö Brädgård',
  'Husqvarna',
  'Onninen',
  'Qlocx',
  'Skanska Rental',
  'Skydda',
  'Sodexo AB',
  'Skyddsrumsmaterial i Sörmland AB',
].map((o) => ({ label: o, value: o }))

const StorageSuppliers = ({ admin, mutateAdmin }) => (
  <div>
    <Select noOptionsMessage={() => 'Tomt'} isMulti isClearable onChange={(list) => mutateAdmin({ ...admin, storageSuppliers: (list || []).map((r) => ({ name: r.value })) })} value={admin.storageSuppliers.map((r) => ({ label: r.name, value: r.name }))} options={options} placeholder="Ex. Company AB" />
  </div>
)

export default StorageSuppliers
